import React, { memo } from 'react';

import CollapseableFilter from './task-status';
import Divider from '@components/divider';

import style from './style.module.scss';

const EquipmentFilterGroups = ({
  equipmentCategoryTags,
  picklistsMap,
  filters,
  updateFilters,
  equipmentTypeTags,
  equipmentSubTypeTags,
  equipmentStatusTags
}) => {
  return (
    <>
      <div className={style.filterHeader}>
        <p>Equipment</p>
      </div>

      <div>
        {equipmentCategoryTags?.length > 0 && (
          <>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Equipment category'}
                tags={equipmentCategoryTags || []}
                tagsMap={picklistsMap}
                multi
                value={filters?.equipmentCategory?.value}
                onChange={(value) => updateFilters('equipmentCategory', 'value', value)}
              />
            </div>
            <Divider />
          </>
        )}
      </div>

      <div>
        {equipmentTypeTags?.length > 0 && (
          <>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Equipment type'}
                tags={equipmentTypeTags || []}
                tagsMap={picklistsMap}
                multi
                value={filters?.equipmentType?.value}
                onChange={(value) => updateFilters('equipmentType', 'value', value)}
              />
            </div>
            <Divider />
          </>
        )}
      </div>

      <div>
        {equipmentSubTypeTags?.length > 0 && (
          <>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Equipment sub type'}
                tags={equipmentSubTypeTags || []}
                tagsMap={picklistsMap}
                multi
                value={filters?.equipmentSubType?.value}
                onChange={(value) => updateFilters('equipmentSubType', 'value', value)}
              />
            </div>
            <Divider />
          </>
        )}
      </div>

      <div>
        {equipmentStatusTags?.length > 0 && (
          <>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Equipment status'}
                tags={equipmentStatusTags || []}
                tagsMap={picklistsMap}
                multi
                value={filters?.equipmentStatus?.value}
                onChange={(value) => updateFilters('equipmentStatus', 'value', value)}
              />
            </div>
            <Divider />
          </>
        )}
      </div>
    </>
  );
};

export default memo(EquipmentFilterGroups);
